import { CheckoutModel } from '../../../api/models/checkout-model';
import { InvoiceModel } from '../pages/address/models/invoice.model';
import { DeliveryModel } from '../pages/address/models/delivery.model';

export class LoadPreviousAddresses {
  static readonly type = '[Checkout] LoadPreviousAddresses';
}

export class LoadSingleOrder {
  static readonly type = '[Checkout] LoadSingleOrder';

  constructor(
    public payload: string,
    public commitPosition: number
  ) {}
}

export class StartNewContinueAsGuestSession {
  static readonly type = '[Checkout] StartNewContinueAsGuestSession';
}

export class Checkout {
  static readonly type = '[Checkout] Checkout';

  constructor(public payload: CheckoutModel) {}
}

export class CreatePayment {
  static readonly type = '[Checkout] CreatePayment';

  constructor(public payload: { orderId: string; position: number }) {}
}

export class ClearAddressErrors {
  static readonly type = '[Checkout] ClearAddressErrors';
}

export class ClearLoginOrGuestErrors {
  static readonly type = '[Checkout] ClearLoginOrGuestErrors';
}

export class UpdateCurrentInvoiceModel {
  static readonly type = '[Checkout] UpdateCurrentInvoiceModel';

  constructor(public payload: InvoiceModel) {}
}

export class UpdateCurrentDeliveryModel {
  static readonly type = '[Checkout] UpdateCurrentDeliveryModel';

  constructor(public payload: Partial<DeliveryModel>) {}
}

export class ClearCheckoutState {
  static readonly type = '[Checkout] ClearCurrentModels';
}

export class CheckoutStartedEvent {
  static readonly type = '[Event][Checkout] CheckoutStarted';
}
